<template>
  <div class="container">
    <div id="printMe" style="width: 100%;">
      <div
        style="text-align: center;">
        <h2>网策科技有限公司</h2>
      </div>
      <div style="position: relative; text-align: center; margin-top: 25px;">
        <span style="font-size: 16px; font-weight: bold;">地址：{{contactAddr}}<span style="margin-left: 10px;">电话：{{contactPhone}}</span></span>
      </div>
      <div style="position: relative; text-align: center; margin-top: 25px;">
        <h2 style="font-size: 26px; font-weight: bold;">发 货 清 单</h2>
      </div>
      <div style="font-weight: bold; margin: 20px 0;">
        <p style="margin: 0;">客户：<span style="margin-left: 10px; text-decoration: underline;">{{customerName}}</span></p>
        <p style="margin: 0;">地址：<span style="margin-left: 10px; text-decoration: underline;">{{customerAddr}}</span></p>
        <p style="margin: 0;">电话：<span style="margin-left: 10px; text-decoration: underline;">{{customerPhone}}</span></p>
        <p style="margin: 0;">日期：<span style="margin-left: 10px; text-decoration: underline;">{{updateAt | toDateFormatFilter}}</span></p>
      </div>
      <table border="1" cellspacing="0" class="table" style="width: 100%; table-layout: fixed;word-break: break-all;">
        <thead>
          <tr style="height: 40px;" width="100%">
            <th rowspan="1" style="width: 8%;">序号</th>
            <th rowspan="1">设备名称</th>
            <th rowspan="1">设备型号</th>
            <th rowspan="1">设备编号</th>
            <th rowspan="1" style="width: 8%;">数量</th>
            <th rowspan="1" style="width: 8%;">单位</th>
            <th rowspan="1">备注</th>
          </tr>
        </thead>
        <tbody>
          <tr style="height: 30px; text-align: center;" width="100%" v-for="(item, index) in deviceListVal" :key="'device' + index">
            <td rowspan="1" style="width: 8%;">{{index + 1}}</td>
            <td rowspan="1">{{item.deviceName}}</td>
            <td rowspan="1">{{item.deviceModel}}</td>
            <td rowspan="1">{{item.deviceNo}}</td>
            <td rowspan="1" style="width: 8%;">{{item.num}}</td>
            <td rowspan="1" style="width: 8%;">{{item.unit}}</td>
            <td rowspan="1">{{item.comment}}</td>
          </tr>
          <tr style="height: 30px; text-align: center;" width="100%" v-for="(item, index) in subDeviceList" :key="'subDevice' + index">
            <td rowspan="1" style="width: 8%;">{{deviceListVal.length + index + 1}}</td>
            <td rowspan="1">{{item.deviceName}}</td>
            <td rowspan="1">{{item.deviceModel}}</td>
            <td rowspan="1">{{item.deviceNo}}</td>
            <td rowspan="1" style="width: 8%;">{{item.num}}</td>
            <td rowspan="1" style="width: 8%;">{{item.unit}}</td>
            <td rowspan="1"><div>{{item.comment}}</div></td>
          </tr>
        </tbody>
      </table>
      <div style="display: flex; justify-content: space-between; margin: 30px 0 0; align-items: center;">
        <div style="width: 60%; padding-left: 10px; box-sizing: border-box;"><span style="font-weight: bold;">送货人：</span><span>{{contactName}}</span></div>
        <div style="width: 40%;">
          <p><span style="font-weight: bold;">收货人签名：</span></p>
          <p style="margin: 8px 0;"><span style="font-weight: bold;">收货日期：</span></p>
          <p><span style="font-weight: bold;">收货盖章：</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import printJS from 'print-js';
import { consignorsList } from '@/api/consignors';
import {deviceDeliveryList} from "@/api/device";

export default {
  name: "DeliveryList",
  data() {
    return {
      contactAddr: '',
      contactName: '',
      contactPhone: '',
      customerName: '',
      customerAddr: '',
      customerPhone: '',
      updateAt: '',
      deviceList: [],
      subDeviceList: [],
    }
  },
  mounted() {
    this.consignorsList();
  },
  computed: {
    deviceListVal() {
      const {
        deviceList,
      } = this;
      if (!deviceList || deviceList && deviceList.length === 0) {
        return  [];
      }
      let deviceListVal = [];
      for (let row of deviceList) {
        deviceListVal.push(row);
        for (let val of row.subDevice) {
          deviceListVal.push(val);
        }
      }
      return deviceListVal;
    }
  },
  methods: {
    async consignorsList() {
      try {
        const resConsignors = await consignorsList({
          perpage: 10,
          page: 1,
        });
        const consignorsData = resConsignors.data;
        let consignor = {};
        if (consignorsData && consignorsData.records && consignorsData.records.length > 0) {
          consignor = consignorsData.records[0];
        }
        this.contactName = consignor.contact;
        this.contactAddr = consignor.contactAddr;
        this.contactPhone = consignor.contactPhone;
        this.deviceDeliveryDetail();
      } catch (e) {
        // do nothing.
      }
    },
    async deviceDeliveryDetail() {
      const {
        deliveryId,
      } = this.$route.params;
      try {
        const res = await deviceDeliveryList({
          id: deliveryId,
        });
        const {data} = res;
        const deliverys = data.records || [];
        if (deliverys.length === 0) {
          this.$message({
            type: 'error',
            message: this.$t('device.deviceDeliveryInfoMissing'),
          });
          return;
        }
        const {
          updateAt,
          customer,
          contactPhone,
          contactAddr,
          devicesHistories,
        } = deliverys[0];
        this.customerName = customer.customerName;
        this.customerAddr = contactAddr;
        this.customerPhone = contactPhone;
        this.updateAt = updateAt;
        if (devicesHistories) {
          let linkedSubDeviceListObj = {};
          this.deviceList = [];
          this.subDeviceList = [];
          let parentDevId;
          for (let row of devicesHistories) {
            if (row) {
              if (row.flag === 100) {
                parentDevId = row.parentDevId;
                if (parentDevId === null) {
                  this.subDeviceList.push(row);
                } else {
                  if (!linkedSubDeviceListObj[parentDevId]) {
                    linkedSubDeviceListObj[parentDevId] = [];
                  }
                  linkedSubDeviceListObj[parentDevId].push(row);
                }
              } else {
                this.deviceList.push(row)
              }
            }
          }
          for (let row of this.deviceList) {
            row.subDevice = linkedSubDeviceListObj[String(row.deviceId)] || [];
          }
        }
        this.$nextTick(() => {
          this.onPrint();
        });
      } catch (e) {
        // do nothing.
      }
    },
    onPrint() {
      const style = '@page { size: auto; } @media print { } *{ margin: 0}';
      printJS({
        printable: 'printMe', // 要打印内容的id
        type: 'html',
        style,
        scanStyles: false,
      });
    },
  }
}
</script>

<style scoped>
.container {
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  color: black;
  padding: 0;
}
</style>
